import { StyleSheet } from "aphrodite";

const stack = "@media (max-width: 768px)";
const col = {
  boxSizing: "border-box",
  minWidth: 0,
  maxWidth: "100%",
};

export const dashboardGridStyles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "stretch",
    width: "100%",
    boxSizing: "border-box",
    marginBottom: 20,
  },
  col60: {
    ...col,
    width: "60%",
    paddingRight: 20,
    [stack]: { width: "100%", paddingRight: 0, marginBottom: 16 },
  },
  col40: {
    ...col,
    width: "40%",
    [stack]: { width: "100%" },
  },
  col75: {
    ...col,
    width: "75%",
    padding: "0 10px",
    [stack]: { width: "100%", padding: 0, marginBottom: 16 },
  },
  col25: {
    ...col,
    width: "25%",
    padding: "0 10px",
    [stack]: { width: "100%", padding: 0 },
  },
  col33: {
    ...col,
    width: "33.33%",
    padding: "0 10px",
    marginBottom: 16,
    [stack]: { width: "100%", padding: 0 },
  },
  col20: {
    ...col,
    width: "20%",
    padding: "0 10px",
    [stack]: { width: "100%", padding: 0, marginBottom: 12 },
  },
  col100: {
    ...col,
    width: "100%",
    padding: "0 10px",
    [stack]: { padding: 0 },
  },
});
